import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import { gsap } from 'gsap';
import createIntervalEmitter, {
  IntervalEmitter,
} from 'src/lib/createIntervalEmitter';

export default class ConfettiOverlay extends View {
  private tiles: ImageScaleView[] = [];
  private emitter: IntervalEmitter<any>;
  private last!: number;

  constructor(opts: { superview: View }) {
    super({
      superview: opts.superview,
      width: opts.superview.style.width,
      height: opts.superview.style.height,
      zIndex: 0,
      blockEvents: true,
    });
    this.createTiles();
    this.emitter = createIntervalEmitter((_, now) => ({ now }), 1);
    this.style.opacity = 0;
  }

  private createTiles() {
    const { width, height } = this.style;
    const baseWidth = 818;
    const baseHeight = 788;
    const tileHeight = (width / baseWidth) * baseHeight;
    const numTiles = Math.ceil(height / tileHeight) + 1;

    for (let index = 0; index < numTiles; index++) {
      const tile = new ImageScaleView({
        superview: this,
        image: 'assets/minigame/match2/confetti.png',
        width,
        height: tileHeight,
        x: width * 0.5,
        y: index * tileHeight,
        anchorX: width * 0.5,
        offsetX: -width * 0.5,
      });
      this.tiles.push(tile);
    }
  }

  public override async show() {
    super.show();
    gsap.to(this.style, { opacity: 1, duration: 1, ease: 'quad.inOut' });
    this.emitter.addListener(this.updateBinded);
  }

  public override async hide() {
    await gsap.to(this.style, { opacity: 0, duration: 0.5, ease: 'quad.in' });
    super.hide();
    this.emitter.removeListener(this.updateBinded);
  }

  private updateBinded = this.update.bind(this);
  private update({ now }: { now: number }) {
    if (!this.last) this.last = now;
    const dt = (now - this.last) * 0.001;
    this.tiles.forEach((tile) => {
      tile.style.y += dt * 200;
      if (tile.style.y > this.style.height) {
        tile.style.y = -tile.style.height;
      }
      tile.style.scale = 1.5 + (tile.style.y / 1500) * 1.2;
    });
    this.last = now;
  }
}
